import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import Integrations from '../../../page/Settings/Integrations';
import Forms from '../../../page/Settings/Forms';
import Email from '../../../page/Settings/Email';
import Subscriptions from '../../../page/Settings/Subscriptions';
import Tracking from '../../../page/Settings/Tracking';
import Installation from '../../../apps';
import AppsContextProvider from '../../../apps/Provider';
import PublicLink from '../../../apps/PublicLink';
import Licensing from '../../../page/Licensing';
import useProvider from '../useProvider';
import InitialRequests from './InitialRequests';

var Bootstrap = function Bootstrap(_ref) {
  var children = _ref.children;
  var context = useProvider();
  var microservice = context.microservice,
      settings = context.settings,
      routes = context.routes,
      extensions = context.extensions;
  var id = microservice.id,
      requiresInstallation = microservice.requiresInstallation,
      requiresLicensing = microservice.requiresLicensing;
  var AppsContextBootstrap = React.Fragment;

  if (microservice.id || extensions) {
    AppsContextBootstrap = AppsContextProvider;
  }

  var InstallationBootstrap = React.Fragment;
  var installationProps = {};

  if (microservice.id && requiresInstallation) {
    if (typeof requiresInstallation !== 'boolean') {
      InstallationBootstrap = Installation.InstallationProvider;
      installationProps = _objectSpread({
        appName: id
      }, requiresInstallation, context.routes);
    }
  }

  var LicensingCheck = React.Fragment;
  var licensingProps = {};

  if (microservice.id && requiresLicensing) {
    LicensingCheck = Licensing.LicensingCheck;
    licensingProps = _objectSpread({
      appName: id
    }, requiresLicensing, context.routes);
  }

  var IntegrationsBootstrap = React.Fragment;
  var integrationsProps = {};

  if (settings && settings.integrations) {
    IntegrationsBootstrap = Integrations.IntegrationsBootstrap;
    integrationsProps = _objectSpread({
      id: id
    }, context.routes, settings.integrations);
  }

  var FormsBootstrap = React.Fragment;
  var formsProps = {};

  if (settings && settings.forms) {
    FormsBootstrap = Forms.FormsBootstrap;
    formsProps = _objectSpread({}, context.routes, settings.forms);
  }

  var EmailBootstrap = React.Fragment;
  var emailProps = {};

  if (settings && settings.email) {
    EmailBootstrap = Email.EmailBootstrap;
    emailProps = _objectSpread({}, context.routes);
  }

  var SubscriptionsBootstrap = React.Fragment;
  var subscriptionsProps = {};

  if (settings && settings.subscriptions) {
    SubscriptionsBootstrap = Subscriptions.SubscriptionsBootstrap;
    subscriptionsProps = _objectSpread({}, context.routes);
  }

  var TrackingBootstrap = React.Fragment;
  var trackingProps = {};

  if (settings && settings.tracking) {
    TrackingBootstrap = Tracking.TrackingBootstrap;
    trackingProps = _objectSpread({}, context.routes);
  }

  var PublicLinkProvider = React.Fragment;
  var publicLinkProps = {};

  if (routes && routes.publicLinks) {
    PublicLinkProvider = PublicLink.PublicLinkProvider;
    publicLinkProps = {
      publicLinks: routes.publicLinks,
      history: routes.history
    };
  }

  return React.createElement(AppsContextBootstrap, null, React.createElement(PublicLinkProvider, publicLinkProps, React.createElement(InitialRequests, null), React.createElement(InstallationBootstrap, installationProps, React.createElement(LicensingCheck, licensingProps, React.createElement(IntegrationsBootstrap, integrationsProps, React.createElement(FormsBootstrap, formsProps, React.createElement(EmailBootstrap, emailProps, React.createElement(SubscriptionsBootstrap, subscriptionsProps, React.createElement(TrackingBootstrap, trackingProps, children)))))))));
};

export default Bootstrap;